import {Component} from '@angular/core';
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {MatDialog} from "@angular/material/dialog";
import {IGameTestimonials} from "../../../interfaces/IGameTestimonials";
import {TestimonialsEditComponent} from "../testimonials-edit/testimonials-edit.component";

@Component({
  selector: 'app-lottery-licence-settings',
  standalone: true,
  imports: [
    HasPermissionDirective,
    MatIcon,
    MatIconButton,
    MatTooltip
  ],
  templateUrl: './testimonials-settings.component.html',
  styleUrl: './testimonials-settings.component.css'
})
export class TestimonialsSettingsComponent implements ICellRendererAngularComp {
  public permissionTypes = PermissionTypes;
  public rowData!: IGameTestimonials;
  public params!: any;

  constructor(private matDialog: MatDialog) {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.rowData = params.data;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }

  onEditTestimonial() {
    this.matDialog.open(TestimonialsEditComponent, {
      data: this.rowData,
      width: '650px'
    });
  }
}
